/**
* Affix
**/

// # init affix
export const affixFafix = () => {
  // $(document).on('DOMContentLoaded load resize scroll touchmove', updateAffix)
  // updateAffix()
}
export const updateAffix = () => {
  // const all = document.querySelectorAll('[data-affix-top]')
  // if (!all.length) {
  //   return
  // }  
  // const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  // all.forEach( (el) => {
  //   updateAffixElement(el, scrollTop)
  // })
}
export const affixOnLocomotiveScroll = (scrollTop) => {
  const all = document.querySelectorAll('[data-affix-top]')
  if (!all.length) {
    return
  }  
  all.forEach( (el) => {
    updateAffixElement(el, scrollTop)
  })
}
const updateAffixElement = (el, scrollTop) => {
  // const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const offset = el.dataset.affixOffset ? el.dataset.affixOffset : 0
  const elAffixTop = getAffixTopValue(el) - offset
  const affixBottom = el.dataset.affixBottom  
  if (elAffixTop >= 0) {
    if (elAffixTop <= scrollTop) {
      el.classList.add("affix-top")
    } else {
      el.classList.remove("affix-top")
    }
  }  

  if (affixBottom) {    
    const body = document.body
    const html = document.documentElement;
    var height = Math.max( body.scrollHeight, body.offsetHeight, 
                       html.clientHeight, html.scrollHeight, html.offsetHeight );
    if (scrollTop + window.innerHeight >= height - parseInt(affixBottom) ) {
      el.classList.add("affix-bottom")
    } else {
      el.classList.remove("affix-bottom")
    }
  }

}
const getAffixTopValue = (el) => {
  let val = -1
  const affixTop = el.dataset.affixTop
  if (!affixTop) {
    return val
  }
  if (isNumber(affixTop)) {
    return affixTop
  }
  // check REM (eg. data-affix-top="3rem")
  if (affixTop.slice(-3) == "rem") {
    const atr = affixTop.replace('rem', '')
    if (isNumber(atr)) {
      return remToPx(atr)
    }
  }
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  switch (affixTop) {
    case "self":
      let rect = el.getBoundingClientRect();
      return rect.top + scrollTop
      break;
    default:
      const target = document.querySelector(affixTop)
      if (target) {
        let targetRect = target.getBoundingClientRect();
        return targetRect.top + scrollTop
      }
      break;
  }
  return val;
}

const isNumber = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export const remToPx = (rem) => {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}